import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const { init } = createAllActions(types.SCOPE);

export const openNocDrawer = () => ({
  type: types.OPEN_NOC_DRAWER,
});

export const setNocUrl = params => ({
  type: types.SET_NOC_URL,
  params,
});

export const closeNocDrawer = () => ({
  type: types.CLOSE_NOC_DRAWER,
});

export const resetTrendsDrawer = () => ({
  type: types.RESET_TRENDS_FILTER,
});

export const resetFiltersDrawer = () => ({
  type: types.RESET_FILTERS_FILTER,
});

export const navigateToTrends = params => ({
  type: types.NAVIGATE_TO_TRENDS,
  params,
});

export const setInitialFiltersToDrawer = params => ({
  type: types.SET_INITIAL_FILTERS_TO_DRAWER,
  params,
});

export const setInitialTrendsFilterToDrawer = params => ({
  type: types.SET_INITIAL_TRENDS_FILTER_TO_DRAWER,
  params,
});

export const addFiltersFromNocDrawer = params => ({
  type: types.NAVIGATE_TO_RT,
  params,
});

export const toggleDimensionInFiltersNocDrawer = (
  dimensionName,
  filterRule,
  dimensionDataObj,
) => ({
  type: types.TOGGLE_DIMENSION_IN_FILTERS_NOC_DRAWER,
  dimensionName,
  filterRule,
  dimensionDataObj,
});

export const toggleDimensionInTrendsNocDrawer = (
  dimensionName,
  filterRule,
  dimensionDataObj,
) => ({
  type: types.TOGGLE_DIMENSION_IN_TRENDS_NOC_DRAWER,
  dimensionName,
  filterRule,
  dimensionDataObj,
});

export const selectNocFiltersFilterBar = currentFilterBar => ({
  type: types.SELECT_NOC_FILTERS_FILTER_BAR,
  currentFilterBar,
});

export const selectNocTrendsFilterBar = currentFilterBar => ({
  type: types.SELECT_NOC_TRENDS_FILTER_BAR,
  currentFilterBar,
});

export const addMetricToFilterBar = metric => ({
  type: types.ADD_METRIC_TO_FILTER_BAR,
  metric,
});

export const addNewNocFiltersFilterBar = scope => ({
  type: types.ADD_NEW_NOC_FILTERS_FILTER_BAR,
  scope,
});

export const addNewNocTrendsFilterBar = scope => ({
  type: types.ADD_NEW_NOC_TRENDS_FILTER_BAR,
  scope,
});

export const deleteNocFiltersFilterBar = (index, newFilterBarDelta, dimensionsObj) => ({
  type: types.DELETE_NOC_FILTERS_FILTER_BAR,
  index,
  newFilterBarDelta,
  dimensionsObj,
});

export const deleteNocTrendsFilterBar = (index, newFilterBarDelta, dimensionsObj) => ({
  type: types.DELETE_NOC_TRENDS_FILTER_BAR,
  index,
  newFilterBarDelta,
  dimensionsObj,
});

export const deleteSavedNocFiltersFilterBar = () => ({
  type: types.DELETE_SAVED_NOC_FILTERS_FILTER_BAR,
});

export const selectMultipleDimensionInNocDrawer = (
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
  savedFiltersCount,
  MAX_NOC_FILTERS,
  SOFT_MAX_NOC_FILTERS,
) => ({
  type: types.SELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER,
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
  savedFiltersCount,
  MAX_NOC_FILTERS,
  SOFT_MAX_NOC_FILTERS,
});

export const unSelectMultipleDimensionInNocDrawer = (
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
) => ({
  type: types.UNSELECT_MULTIPLE_DIMENSION_FROM_DIMESION_HEADER,
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
});
